import "./App.css";
import Elon from "./images/elon.png";
import Logo from "./images/logo.png";
import Sam from "./images/sam.png";
import Head1 from "./images/head1.png";
import Head2 from "./images/head2.png";
import new_section from "./images/new_section.jpg";
import OpenAI from "./images/open-ai-img.jpg";
import Arrow1 from "./images/arrow1.png";
import Arrow2 from "./images/arrow2.png";
import ProgressBar from "./components/ProgressBar";
import { useEffect, useState } from "react";
import PostModal from "./components/PostModal";
import Heading from "./components/Heading";
import {
  checkPhantomWallet,
  connectWallet,
  disconnectWallet,
  attachWalletEventListeners,
  saveWalletAddress,
  getWalletAddress,
  removeWalletAddress,
} from "./assets/js/phantomWallet";
import toast, { Toaster } from "react-hot-toast";
import axios from "axios";
import Post from "./components/Post";

export const base_url = "https://www.altmusk.com/api/";
function App() {
  const weekDays = [
    { day: "Airdrop 1", date: "February 5" },
    { day: "Airdrop 2", date: "February 26" },
    { day: "Airdrop 3", date: "March 19" },
  ];
  const [type, setType] = useState("");
  const [user, setUser] = useState();
  const [Posts, setPosts] = useState([]);
  const [NewPostData, setNewPostData] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [walletAddress, setWalletAddress] = useState(getWalletAddress());

  const params = new URLSearchParams(window.location.search);
  const code = params.get("referral_code");

  useEffect(() => {
    const walletStatus = checkPhantomWallet();
    if (
      walletStatus == "Phantom Wallet not found. Please install Phantom Wallet."
    ) {
      toast.error(walletStatus);
    }

    if (localStorage.getItem("access")) {
      getUser();
    }
    getPosts();
  }, []);

  const getUser = () => {
    axios
      .get(`${base_url}auth/user`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      })
      .then(
        (res) => {
          setUser(res.data);
          localStorage.setItem("user", JSON.stringify(res.data));
        },
        (err) => {
          if (err.response.status) {
            setWalletAddress(null);
            localStorage.removeItem("walletAddress");
          }
        }
      );
  };

  const getPosts = () => {
    axios
      .get(`${base_url}posts`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access")}`,
        },
      })
      .then((response) => {
        setPosts(response.data.data);
      });
  };

  const walletDisconnect = async () => {
    const result = disconnectWallet();
    if (!result.connected) {
      axios
        .post(
          `${base_url}auth/logout/`,
          {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          }
        )
        .then(
          (res) => {
            setWalletAddress();
            setUser();
            localStorage.clear();
            getPosts();
          },
          (err) => {
            console.log(err);
          }
        );
    }
  };

  const walletConnect = async () => {
    const result = await connectWallet();

    let data = {
      wallet_address: result.publicKey,
    };

    if (code) {
      data["referral_code"] = code;
    }

    if (result.connected) {
      setWalletAddress(result.publicKey);
      localStorage.setItem("walletAddress", result.publicKey);

      axios.post(`${base_url}auth/login/wallet/`, data).then(
        (res) => {
          localStorage.setItem("access", res.data.data.access);
          setTimeout(() => {
            getUser();
            getPosts();
          }, 500);
        },
        (err) => {
          console.log(err);
        }
      );

      setWalletAddress(result.publicKey);
      saveWalletAddress(result.publicKey);
      toast.success("Connected Successfull");
    } else {
      // setStatus(result.error || "Connection failed.");
      toast.error(
        "Connection failed. Ensure Phantom extension is installed and enabled."
      );
    }
  };

  const copyAddress = () => {
    navigator.clipboard
      .writeText(
        window.location.origin + `/?referral_code=${user?.referral_code}`
      )
      .then(
        () => {
          setTimeout(() => {
            toast.success("Copied");
          }, 500);
        },
        (err) => {
          toast.error("Could not copy wallet address");
          console.error("Could not copy text: ", err);
        }
      );
  };

  const handleVote = async (post, voteType) => {
    const token = localStorage.getItem("access");
    if (!token) {
      toast.error("Please connect your phantom wallet to vote");
      return;
    }
    await axios
      .post(
        `${base_url}votes/`,
        {
          post_id: post.id,
          vote_type: voteType,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        }
      )
      .then((response) => {
        const updatedPost = response.data.data.post;

        setPosts((prevPosts) =>
          prevPosts.map((p) => (p.id === updatedPost.id ? updatedPost : p))
        );
        toast.success(response.data.message, { position: "top-center" });
      })
      .catch((err) => {
        toast.error(err.response.data.message, { position: "top-center" });
      });
  };

  const handleAddComment = async (postId, commentText, clearInput) => {
    if (!commentText.trim()) {
      toast.error("Comment cannot be empty!", { position: "top-center" });
      return;
    }

    try {
      const response = await axios.post(
        `${base_url}comments/`,
        {
          post_id: postId,
          text: commentText,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        }
      );

      // const updatedPost = response.data.data.post;
      // setPosts((prevPosts) =>
      //   prevPosts.map((p) => (p.id === updatedPost.id ? updatedPost : p))
      // );

      axios
        .get(`${base_url}posts/${postId}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        })
        .then((response) => {
          setPosts((prevPosts) =>
            prevPosts.map((p) => (p.id === postId ? response.data.data : p))
          );
        });

      clearInput();
      toast.success("Comment added successfully!", { position: "top-center" });
    } catch (err) {
      toast.error(err.response?.data?.message || "An error occurred.", {
        position: "top-center",
      });
    }
  };

  useEffect(() => {
    if (NewPostData) {
      setPosts((prev) => [NewPostData, ...prev]);
    }
  }, [NewPostData]);

  const toggleModal = () => setIsModalOpen((prev) => !prev);

  const openModal = (type) => {
    setType(type);
    setIsOpen(true);
  };

  return (
    <div className="App">
      <div className="">
        <div className="main-section">
          <div className="hero-header">
            <div className="logo">
              <img src={Logo} alt="Icon" />
            </div>
            <div className="buttons">
              {walletAddress ? (
                <div className="relative flex items-center gap-2">
                  <button className="flex items-center gap-1 bg-[#FF4115] text-white p-1 px-2 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-coins"
                    >
                      <circle cx="8" cy="8" r="6" />
                      <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
                      <path d="M7 6h1v4" />
                      <path d="m16.71 13.88.7.71-2.82 2.82" />
                    </svg>{" "}
                    {user?.points}
                  </button>
                  <div className="relative">
                    <div id="bouton" className="relative group/bouton w-full">
                      <button className="size-12">
                        <img
                          src="https://cdn.pixabay.com/photo/2018/11/13/22/01/avatar-3814081_640.png"
                          alt="user"
                          className="w-full rounded-full"
                        />
                      </button>

                      <div className="fixed right-2 z-10 p-2 w-[20vw] rounded-2xl bg-white opacity-0 hidden group-hover/bouton:flex group-hover/bouton:opacity-100 transition-all">
                        <div className=" bg-gray-200 p-3 rounded-xl w-full">
                          <span className="flex items-center gap-2 border-b-2 border-gray-300 pb-4">
                            <img
                              src="https://cdn.pixabay.com/photo/2018/11/13/22/01/avatar-3814081_640.png"
                              alt="user"
                              className="size-8 rounded-full"
                            />
                            <p className="!text-sm font-medium whitespace-nowrap text-ellipsis overflow-hidden">
                              {walletAddress}
                            </p>
                          </span>
                          <span className="border-b border-blue-500 py-4 inline-block w-full">
                            <div>
                              <p className="text-sm font-medium text-start text-blue-500 mb-1">
                                Your referral_code Link
                              </p>
                              <span className="flex items-center ">
                                <p className=" whitespace-nowrap text-ellipsis overflow-hidden">
                                  {window.location.origin +
                                    `/?referral_code=${user?.referral_code}`}
                                </p>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-copy"
                                  style={{ cursor: "pointer" }}
                                  onClick={copyAddress}
                                >
                                  <rect
                                    width="14"
                                    height="14"
                                    x="8"
                                    y="8"
                                    rx="2"
                                    ry="2"
                                  />
                                  <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                </svg>
                              </span>
                            </div>
                          </span>
                          <button
                            className="button w-full mt-4"
                            onClick={walletDisconnect}
                          >
                            Disconnect
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <button onClick={walletConnect} className="button">
                  Connect
                </button>
              )}
            </div>
          </div>
          <div className="button-flex">
            <Modal isOpen={isOpen} setIsOpen={setIsOpen} Type={type} />
            <button className="button" onClick={() => openModal("buy&vs")}>
              BUY $VS
            </button>
            <button className="button" onClick={() => openModal("musk")}>
              Wager Musk
            </button>
            <button className="button" onClick={() => openModal("altman")}>
              Wager Altman
            </button>
          </div>

          <div className="img-content">
            <div className="side1">
              <div>
                <img src={Elon} alt="Icon" className="side-img" />
              </div>
              <div className="side-text1">
                <p>
                  ELON MUSK SUES OPENAI, RENEWING CLAIMS CHATGPT-MAKER PUT
                  PROFITS BEFORE THE BENEFIT OF HUMANITY.
                </p>
              </div>
            </div>
            <div className="absolute-Vs">
              <Heading Heading="VS" />
            </div>
            <div className="Vs">
              <Heading Heading="VS" />
            </div>
            <div className="side2">
              <div>
                <img src={Sam} alt="Icon" className="side-img" />
              </div>
              <div className="side-text2">
                <p>
                  OPEN AI SAM ALTMAN CALLS FORMER BUSINESS PARTNER ELON MUSK “A
                  BULLY”
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="background-section p-10">
        <div class="card ">
          <h2>RULES</h2>
          <ul>
            <li>Wager your tokens in either Musk pool or Altman pool</li>
            <li>Engage with the community to earn points</li>
            <li>Wager tokens and refer friends for big points</li>
            <li>Points leaderboard will reward the winning side with an airdrop multiplier</li>
            <li>3 airdrops prior to verdict</li>
            <li>
              When the lawsuit is verifiably decided via a decentralized AI agent, the 
              <span> Winning side distributes all losing side's tokens </span>
            </li>
            <li>The winner takes it all</li>
          </ul>
        </div>
      </section>


      <section className="w-full" style={{display:"none"}}>
        <div className="">
          <div className="Leaderboard-section">
            <Heading Heading="Leaderboard" />
            <div className="progress-content-data">
              <div className="progress-bar-container">
                <div className="progress-bar">
                  <div className="progress" data-progress="0">
                    <img
                      src={Head1}
                      alt="Progress Icon"
                      className="progress-icon"
                    />
                  </div>
                </div>
              </div>
              <div className="progress-bar-container">
                <div className="progress-bar">
                  <div className="progress" data-progress="0">
                    <img
                      src={Head2}
                      alt="Progress Icon"
                      className="progress-icon"
                    />
                  </div>
                </div>
              </div>
            </div>
            <Heading className="airdrop-clr" Heading="Airdrop Events" />
            <div className="week-content !mt-4 max-md:flex-col max-md:gap-3">
              {weekDays.map((item, index) => (
                <div
                  key={index}
                  className="week-day max-md:w-full max-md:py-5 max-md:bg-[#121212] max-md:rounded-xl"
                >
                  <p>{item.day}</p>
                  <Heading Heading={item.date} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Post */}
      <section className="OpenAI-section w-full bg-gradient-to-b from-[#FE4115] to-[#952910]">
        {walletAddress && (
          <div>
            <button
              className="button"
              onClick={toggleModal}
              style={{
                fontSize: "20px",
                marginTop: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "30px auto 0px ",
                background: "black",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-plus"
              >
                <path d="M5 12h14" />
                <path d="M12 5v14" />
              </svg>{" "}
              Post
            </button>
            <PostModal
              isOpen={isModalOpen}
              onClose={toggleModal}
              setNewPostData={setNewPostData}
            />
          </div>
        )}
      </section>
      <Toaster position="top-right" reverseOrder={false} />
    </div>
  );
}

export default App;

const Modal = ({ Type, isOpen, setIsOpen }) => {
  return (
    <>
      <div
        className={`modal-overlay ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(false)}
      ></div>
      <div
        className={` overflow-auto no-scrollbar buttonModal ${isOpen ? "open" : ""
          }`}
      >
        <div className="modal-content">
          <h2 className="my-3 font-medium text-xl">
            {Type == "musk"
              ? "Wager Musk"
              : Type == "altman"
                ? "Wager Altman"
                : "Buy &vs"}
          </h2>
          <p className="my-3 font-medium">
            {Type == "musk"
              ? "Click below to visit our official Musk staking group"
              : Type == "altman"
                ? "Click below to visit our official Altman staking group"
                : "To purchase our token please visit us in"}
          </p>
          <div className="flex items-center justify-end gap-3">
            {Type == "musk" ? (
              <a href="https://t.me/MUSK_VS">
                <button className="!w-fit button !px-3 !py-[5px]">
                  Visit Musk Group
                </button>
              </a>
            ) : Type == "altman" ? (
              <a href="https://t.me/ALTMAN_VS">
                <button className="!w-fit button !px-3 !py-[5px]">
                  Visit Altman Group
                </button>
              </a>
            ) : (
              <a href="https://jup.ag/">
                <button className="!w-fit button !px-3 !py-[5px]">
                  Visit Jupiter
                </button>
              </a>
            )}
            <button
              className="!w-fit button !px-3 !py-[5px]"
              onClick={() => setIsOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
